import { PlotReportFactElement } from '@/api/rest/resources/types/fact';
import { UnitEnum } from '@/api/rest/resources/types/units';
import { CARBON_TONNES_TO_CO2_MULTIPLIER } from '@/config/constants';

import { formatFactKilogramsToTonnes } from './formatKgToTon';

// Converts a carbon fact to its CO2 equivalent.
export const formatFactCarbonToCO2 = <T>(fact?: PlotReportFactElement<T>): PlotReportFactElement<T> | undefined => {
  if (!fact) return fact;

  if (!fact.name.includes('carbon')) {
    return fact;
  }

  const factInTonnes = formatFactKilogramsToTonnes(fact);

  if (factInTonnes?.value === undefined || factInTonnes?.value === null) return factInTonnes;

  const co2Value = Number(factInTonnes.value) * CARBON_TONNES_TO_CO2_MULTIPLIER;

  return {
    ...factInTonnes,
    value: co2Value as T,
    unit: [UnitEnum.kg, UnitEnum.t].includes(factInTonnes.unit) ? UnitEnum.t_CO2 : UnitEnum['t_CO2/ha'],
  };
};
